import { featuredCategories } from '@/mocks/categories';

export default function FeaturedGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-4">
          Najlepsze Kategorie
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-xl mx-auto mb-12">
          Odkryj najpopularniejsze kategorie w naszym{' '}
          <strong>Kakobuy Spreadsheet</strong>. Każda kategoria zawiera starannie wybrane produkty z najlepszymi cenami.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
            >
              <div className="aspect-[3/4] w-full">
                <img
                  src={cat.image}
                  alt={`${cat.name} Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-background-50/80">
                  Zobacz produkty w {cat.name}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}